<script lang="ts" setup>
import type { IContest } from '~/api/contest'
const props = defineProps({
  data: {
    type: Object as PropType<IContest>,
    default: {}
  }
})
</script>

<template>
  <div class="content">
    <div class="content__top">
      <div class="content__category">{{ data.category?.name || '' }}</div>
      <div class="content__social">
        <button class="content__social__icon buttonReset">
          <ButtonFavorite type="project" :id="data.id" />
        </button>
        <button class="content__social__icon buttonReset">
          <ButtonShare class="card__icon__item" :link="$route.fullPath" />
        </button>
      </div>
    </div>
    <div class="content__title">
      <div class="content__titleEn">{{ data.en_title }}</div>
      <h1 class="content__titleTw">{{ data.title }}</h1>
    </div>
    <div class="content__text" v-if="!isEmpty(data.deadline)">
      {{ $t("deadline") }}
      {{ useDateFormat(data.deadline, "MMM.DD, YYYY", { locales: "en-US" }).value }}
    </div>
    <div class="textEditor">
      <BlockGBlockOneImg :block="{ type: 'block_one_img', data: { image: data.image } }" />
      <Block :data="data.content" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content {
  margin-bottom: 240px;

  @include max-media(480) {
    margin-bottom: 120px;
  }

  &__top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
  }

  &__category {
    font-size: 14px;
    font-weight: 400;
    color: #999696;
    font-family: $font-NotoSans;

    @include max-media(480) {
      font-size: 10px;
    }
  }

  &__social {
    display: flex;
    align-items: center;

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;

      &.content__social__fav {
        width: 20px;
        height: 20px;
      }

      @include max-media(480) {
        width: 13px;
        height: 13px;
      }

      &:not(:last-child) {
        margin-right: 16px;

        @include max-media(480) {
          margin-right: 12px;
        }
      }

      svg {
        display: block;
        width: 100%;
      }
    }
  }

  &__title {
    margin-bottom: 30px;
    font-size: 18px;

    @include max-media(480) {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }

  &__titleTw {
    @include max-media(480) {
      font-size: 15px;
    }
  }

  &__titleEn {
    @include max-media(480) {
      font-size: 15px;
    }
  }

  &__text {
    font-size: 13px;
    color: rgba(#000, 0.8);

    @include max-media(480) {
      font-size: 9px;
      text-decoration: underline;
    }
  }

  .textEditor {
    padding-top: 45px;

    figure {
      img {
        display: block;
        width: 100%;
      }
    }

    ::v-deep p:empty {
      min-height: 2em;
    }

    ::v-deep h1 {
      font-size: 2em;
    }

    ::v-deep h2 {
      font-size: 1.5em;
    }

    ::v-deep h3 {
      font-size: 1.17em;
    }

    ::v-deep h4 {
      font-size: 1em;
    }

    ::v-deep h5 {
      font-size: 0.83em;
    }

    ::v-deep h6 {
      font-size: 0.67em;
    }

    ::v-deep strong {
      font-weight: bold;
    }
  }
}

.linkMore {
  font-size: 16px;
  font-family: $font-NotoSans;
  text-decoration: underline;
}

.gAreaText {
  padding: 60px 130px;
  text-align: justify;

  @include max-media(767) {
    padding: 50px 35px;
  }

  @include max-media(580) {
    padding: 35px;
  }

  &__title {
    margin-bottom: 40px;
    font-size: 21px;
    color: rgba(#000, 0.8);
    line-height: 1.32;

    @include max-media(480) {
      font-size: 14px;
      margin-bottom: 35px;
    }
  }

  &__text {
    font-family: $font-NotoSans;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.92;

    @include max-media(480) {
      font-size: 12px;
    }
  }
}
</style>
